import * as Yup from "yup";

export type BankStatementUploadFile = { name: string; objectKey: string };

export const createUploadBankStatementsSchema = (
  initialBankName: string | null,
  bankNameRequiredError: string,
  uploadFileRequiredError: string
) =>
  Yup.object({
    bank_name: Yup.string()
      .trim()
      .required(bankNameRequiredError)
      .default(initialBankName || ""),
    file_uploads: Yup.array().min(1, uploadFileRequiredError).of(Yup.object<BankStatementUploadFile>()).default([]),
  });
